import React from "react";
import { defineMessages } from "react-intl";
import TextField from "./TextField";

const messages = defineMessages({
  invalidEmailFieldError: {
    id: "invalidEmailFieldError",
    defaultMessage: "A valid e-mail address is required"
  },

  emailPlaceholder: {
    id: "emailPlaceholder",
    defaultMessage: "email@domain.com"
  }
});

const EmailField = props => (
  <TextField
    placeholder={messages.emailPlaceholder}
    {...props}
    autoCapitalize="none"
    keyboardType="email-address"
  />
);

export default EmailField;
